import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { CompendiumService } from '../compendium.service';
import { Compendium } from '../compendium';
import { PropertyService } from '@app/_components/property/property.service';
import { DevelopmentService } from '@app/_components/development/development.service';
import { CompendiumShortTermRentalJoinService } from '@app/_components/compendium-short-term-rental-join/compendiums-short-term-rental-join.service';
import { PickList } from 'primeng/picklist';

@Component({
    selector: 'app-compendium',
    templateUrl: './compendium.component.html',
    styleUrls: ['./compendium.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class CompendiumComponent implements OnInit {

	@ViewChild('pickList') pickList: PickList;
	properties: any[]=[];
	developments: any[]=[];

	sourceProperties: any[]=[];
	targetProperties: any[]=[];
	compendiumShortTermRentalJoins: any[]=[];
	isDataLoaded = false;
	selectedFilter: string;
	filters: any;
	compendiumObj: any[] = [];
	shortTermRentalIds: any[] = [];
	isSearching = false;
	targetPropertyLength: number;
	locationTypes: any;
	locationAreas: any;
	locations: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private renderer: Renderer2,
		private compendiumService: CompendiumService,
		private compendiumShortTermRentalJoinService: CompendiumShortTermRentalJoinService,
		private propertyService: PropertyService,
		private developmentService: DevelopmentService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.compendium = data.compendium,
			this.statuses = compendiumService.statuses;
			this.selectedFilter = "propertyCode";
			this.filters = compendiumService.filters;
			this.locationTypes = compendiumService.locationTypes;
			this.locationAreas = compendiumService.locationAreas;
			this.locations = compendiumService.locations;
	}

	@Input() compendium: Compendium;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	compendiumId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'compendiumId': [],
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'description': [],
		'status': [],
		'locationType': [],
		'locationArea': [],
		'featureName': [],
		feature: [],
		featureSortOrder: [],
		featureNameSortOrder: [],
		externalUrl: [],
		developmentId: [],
		locationId: [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.fetchProperties();
		this.fetchDevelopments();

		// if we were passed the whole compendium object
		if (this.compendium) {
			this.compendiumId = this.compendium.compendiumId;
			this.fixDates();
			this.form1.patchValue(this.compendium);
		}
	}

	fetchProperties() {
		try {
			this.propertyService.propertySummaryForShortData()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
						if (this.compendium) {
							this.compendiumId = this.compendium.compendiumId;
							this.fetchCompendiumShortTermRentalJoinByCompendiumId();
						}

						return this.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	fetchCompendiumShortTermRentalJoinByCompendiumId() {
		try {
			this.compendiumShortTermRentalJoinService.getAllByCompendiumId(this.compendiumId)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.compendiumShortTermRentalJoins = res.data.compendiumShortTermRentalJoins;
						// this.isDataLoaded = false;
						this.targetProperties = [];
						this.sourceProperties = [];
						
						this.properties.forEach(property => {
							const compendiumHaveProperty = this.compendiumShortTermRentalJoins.find((e: any) => e.shortTermRentalId == property.shortTermRentalId);
							if(compendiumHaveProperty != null) {
								this.targetProperties.push(property);
							}else{
								this.sourceProperties.push(property);
							}
						});
						this.isDataLoaded = true;
						this.primengConfig.ripple = true;
						
						// return this.orderProductShortTermRentalJoins;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	// this.propertyService.findAllSummaryWithStatusActiveAndSuspended()
	// fetchProperties() {
	// 	try {
	// 		this.propertyService.propertySummaryForShortData()
	// 			.subscribe(
	// 				res => {
	// 					// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
	// 					this.properties = res.data.properties;
	// 				},
	// 				err => {
	// 					console.log('Feature-Update FAIL: ' + JSON.stringify(err));
	// 					this.alertService.error(err);
	// 				},
	// 				() => { });
	// 	} catch (error) {
	// 		console.log('Form Invalid: ' + JSON.stringify(error));
	// 		this.alertService.error(error);
	// 	}
	// }

	fetchDevelopments() {
		try {
			this.developmentService.getDevelopmentSummary()
				.subscribe(
					res => {
						this.developments = res.data.developments;
					},
					err => {
						console.log('fetchDevelopments FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.compendiumId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.compendiumService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.compendium = res.data.compendium;
						this.doAdd.emit(this.compendium);
					},
					(err: any) => {
						console.log('compendium-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('compendium: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.compendiumService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.compendium = res.data.compendium;
						this.doUpdate.emit(this.compendium);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.compendiumService.delete(this.compendium.compendiumId)
				.subscribe(
					(res: any) => {
						console.log('compendium-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.compendium);
					},
					(err: any) => {
						console.log('compendium-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			compendiumId: [this.compendiumId],
			name: ['', Validators.required],
			description: [],
			status: [],
			locationType: [],
			locationArea: [],
			featureName: [],
			feature: [],
			featureSortOrder: [],
			featureNameSortOrder: [],
			externalUrl: [],
			// Scope keys: set when locationType = 'development' or 'location'
			developmentId: [],
			locationId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.compendium.compendiumDate = moment(this.compendium.compendiumDate).toDate();
	}

	selectedFilters(event: any){
		this.selectedFilter = event.value;
	}

	moveAllToTarget(event: any){ 
		this.compendiumObj = [];
		event.items.forEach(property => {
			const dataObj = {
				"compendiumId":this.compendiumId,
				"shortTermRentalId":property.shortTermRentalId,
				"status":this.form1.value.status,
				"description":this.form1.value.description,
				"locationType":this.form1.value.locationType,
				"locationArea":this.form1.value.locationArea,
				"featureName":this.form1.value.featureName,
				"feature":this.form1.value.feature,
				"featureSortOrder":this.form1.value.featureSortOrder,
				"featureNameSortOrder":this.form1.value.featureNameSortOrder,
				"externalUrl":this.form1.value.externalUrl,
			}
			this.compendiumObj.push(dataObj)
		});
		this.formAddCompendiumShortTermRentalJoin(this.compendiumObj);
    }

	moveToTarget(event: any){ 
		this.compendiumObj = [];
		event.items.forEach(property => {
			const dataObj = {
				"compendiumId":this.compendiumId,
				"shortTermRentalId":property.shortTermRentalId,
				"status":this.form1.value.status,
				"description":this.form1.value.description,
				"locationType":this.form1.value.locationType,
				"locationArea":this.form1.value.locationArea,
				"featureName":this.form1.value.featureName,
				"feature":this.form1.value.feature,
				"featureSortOrder":this.form1.value.featureSortOrder,
				"featureNameSortOrder":this.form1.value.featureNameSortOrder,
				"externalUrl":this.form1.value.externalUrl,
			}
			this.compendiumObj.push(dataObj)
		});
		this.formAddCompendiumShortTermRentalJoin(this.compendiumObj);
    } 

	moveAllToSource(event: any){ 
		this.shortTermRentalIds = [];
		event.items.forEach(property => {
			this.shortTermRentalIds.push(property.shortTermRentalId)
		});
		this.deleteCompendiumShortTermRentalRelationship(this.shortTermRentalIds);
    } 
    moveToSource(event: any){ 
		this.shortTermRentalIds = [];
		event.items.forEach(property => {
			this.shortTermRentalIds.push(property.shortTermRentalId)
		});
		this.deleteCompendiumShortTermRentalRelationship(this.shortTermRentalIds);
    } 

	deleteCompendiumShortTermRentalRelationship(shortTermRentalIds: any[]) {
		this.isSearching = true;
		try {
			this.compendiumShortTermRentalJoinService.deleteCompendiumShortTermRentalsRelationship(this.compendiumId, shortTermRentalIds)
				.subscribe(
					(res: any) => {
						this.isSearching = false;
						// console.log('orderProductShortTermRentalJoin-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Successfully move into Available Units" });
						this.targetPropertyLength = this.targetProperties.length;
					},
					(err: any) => {
						this.isSearching = false;
						console.log('orderProductShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });
		} catch (error) {
			this.isSearching = false;
			this.alertService.error(error);
		}
	}

	formAddCompendiumShortTermRentalJoin(compendiumObj: any[]) {
		this.isSearching = true;
		try {
			this.compendiumShortTermRentalJoinService.addAll(compendiumObj)
				.subscribe(
					(res: any) => {
						this.isSearching = false;
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Successfully move into Selected Units" });
						this.targetPropertyLength = this.targetProperties.length;
						let orderProductShortTermRentalJoin = res.data.orderProductShortTermRentalJoin;
					},
					(err: any) => {
						this.isSearching = false;
						console.log('orderProductShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.isSearching = false;
			this.alertService.error(error);
		}
	}

	reloadProperties(event: any){
		// this.sourceProperties = [];
		// this.targetProperties.splice
		const index = this.targetProperties.findIndex(x => x.shortTermRentalId === event.shortTermRentalId);
		this.sourceProperties.push(this.targetProperties[index]);
		this.targetProperties.splice(index);
		const dataTableRef = this.renderer.selectRootElement(this.pickList.el.nativeElement, true);
    dataTableRef.focus();
	this.fetchCompendiumShortTermRentalJoinByCompendiumId();

	}

	
}
